import * as actionType from './actionTypes';

const initialState = {
  loaded: false,
  flags: {},
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionType.SET_FLAGS:
      return { ...state, flags: action.payload || {} };
    case actionType.SET_LOADED:
      return { ...state, loaded: action.payload };
    default:
      return state;
  }
};

export default reducer;
